import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useProfileStore = defineStore('profile', () => {

    const configStore   = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    const profile           = ref({})
    const profileProcess    = ref(false)
    const profileMsg        = ref({})

    async function readProfile(paramUuid) {

        profileProcess.value = true
        const token = tokenStore.access

        if(token) { 

            let uuid = paramUuid || localStorage.getItem('UTA_UUID') || false
            
            if(uuid) {
                const request = await requestsStore.fetchRequest({
                    address: `${configStore.httpServer}/users/${uuid}`, 
                    method: 'GET', 
                    token
                })
    
                if(!request.error) {
                    profile.value = request
                    profileMsg.value = { success: true }
                } else {
                    profile.value = {}
                    profileMsg.value = { success: false, text: request.error }
                }

            } else {
                profileMsg.value = { success: false, text: 'EProfileUuid' }
                return profile.value
            }

        } else {
            profileMsg.value = { success: false, text: 'EToken' }
        }

        profileProcess.value = false
        return profile.value
    }

    const setProfile = data => profile.value = data

    return {
        profile,
        profileProcess,
        profileMsg,
        readProfile, 
        setProfile
    }
})
